var hotelList = vueIfExists({
    mixins: [win.map, win.buttonSpinner, win.availCheckMixin, win.toggleCollapse, 
        win.hotelListItem, win.displayPrice],
	el: '#hotel-list',
	data: {
		sharedState: store.state,
        hotels: [],
        handle: null,
        panelCollapsed: {
            'hotels-filter': true,
            'hotels-sort': true
        },
        loading: true,
        noResults: false,
        cache: {
            handle: null,
            query: {},
            expiresSec: 5 * 60,
            time: 0,
            offset: 0
        },
        handlePolling: null,
        sortOrder: {5: 'desc'},
        sortBy: 0,
        offset: 0,
        limit: 15,
        availableHotels: 0,
        totalHotels: 0,
        listTotal: 0,
        searchRadius: 0,
        maxRadius: 100,
        withoutAvailability: true
	},
    computed: {
        searchHeader: function() {
            // 1: city, 3: landmark nearby, distance sort, 4: province & region, 5: airport, 7: district 
            var str = this.i18n.XhotelsFoundIn;
            if (this.sharedState.query.dstt == 3) {
                str = this.i18n.XhotelsFoundNear;
            } else if (this.sharedState.query.dstt == 5) {
                str = this.i18n.XhotelsFoundNearAirport;
            }
            str = str.replace('%0%', this.listTotal)
                .replace('%1%', this.sharedState.query.dsts)
                .replace('%2%', this.i18n.airport)
                .replace('%3%', this.sharedState.query.dsti);
            if (this.listTotal) {
                str += ', '+this.i18n.showing + ' ' + (this.offset + 1) + ' - '+ (Math.min(this.offset + this.limit, this.listTotal));
            }
            var themeCamelCase;
            if (this.sharedState.searchTheme && str.indexOf('Hotels') != -1) {
                themeCamelCase = this.sharedState.searchTheme.replace(/-([a-z])/g, function (g) { return g[1].toUpperCase(); });
                if (this.i18n[themeCamelCase+'Title']) {
                    str = str.replace('Hotels', this.i18n[themeCamelCase+'Title']);
                }
            }
            return str;
        },
        getMapSrc: function() {
            var $map = gE('map'),
                width = $map ? $map.clientWidth : 236,
                height = $map ? $map.clientHeight : 80;
            return this.mapThumbSrc(width, height);
        },
        paginatorPages: function() {
            var maxPages = 10,
                totalPages = Math.ceil(this.listTotal / this.limit),
                currentPage = Math.floor(this.offset / this.limit),
                pageIndex = currentPage - 1;
                pages = [currentPage];

            while (pageIndex >= 0 && pageIndex >= currentPage - 5) {
                pages.unshift(pageIndex--);
            }
            pageIndex = currentPage + 1;
            while (pageIndex < totalPages && ( pageIndex <= currentPage + 5 || pages.length < 10)) {
                pages.push(pageIndex++);
            }
            pageIndex = pages[0] -1;
            while (pageIndex >= 0 && pages.length < 10) {
                pages.unshift(pageIndex--);
            }
            return pages;
        },
        hasDistanceSort: function() {
            return this.sharedState.query.dstt == 3 || this.sharedState.query.dstt == 5;
        },
        lengthOfStay: function() {
            var startDate = win.calendar.parseDate(this.sharedState.query.start),
                endDate = win.calendar.parseDate(this.sharedState.query.end);
            return win.calendar.diffDays(endDate, startDate);
        },
        showSuggestions: function() {
            return (this.sharedState.errorType == 'noResults' || !this.loading && this.listTotal <= this.limit) && 
                (this.sharedState.query.stars || this.sharedState.query.typ!='0' ||
                this.sharedState.query.fac!='0' || this.lengthOfStay == 1 || this.searchRadius < this.maxRadius);
        },
        isFormInputError: function() {
            return this.sharedState.errorType && ['noSearch', 'noDates', 'datesPast', 'datesApart', 'datesMismatch']
                .indexOf(this.sharedState.errorType) != -1;
        },
        isGeneralError: function() {
            return this.sharedState.errorType && this.sharedState.errorType != 'noResults' && ( ['noSearch', 'noDates', 'datesPast', 'datesApart', 'datesMismatch']
                .indexOf(this.sharedState.errorType) == -1 || win.isMobile);
        }
    },
    mounted: function() {
        this.currencyDecimals = 0;
        this.initSearchResultList();
        window.addEventListener('popstate', this.onHistoryChange);
        window.setInterval(this.pollTotalResults, 5000);
    },
	methods: {
        initSearchResultList: function() {
            this.setOffset($url.getVar('offset') || this.sharedState.query.offset);
            this.searchRadius = this.sharedState.query.rad;
            if (this.sharedState.query.sort) {
                var sortArr = this.sharedState.query.sort.split('_');
                this.sortBy = parseInt(sortArr[0]);
                if (this.sortOrder[this.sortBy]) this.sortOrder[this.sortBy] = sortArr[1];
            }
            if (this.sharedState.query.dsti && this.sharedState.query.dsts) {
                this.withoutAvailability = !(this.sharedState.query.start && this.sharedState.query.end);
                win.store.set('query.wa', this.withoutAvailability ? 1 : 0);
                var result;
                if (!this.withoutAvailability) {
                    result = win.calendar.validateDates(this.sharedState.query.start, this.sharedState.query.end );
                }
                if (this.withoutAvailability || result.valid) {
                    this.getHotels({
                        query: this.sharedState.query,
                        offset: this.offset
                    });
                } else {
                    this.sharedState.errorType = result.errorType;
                    this.loading = false;
                    if (this.isFormInputError) {
                        this.toggleCollapse(null, { expand: true, target: 'hotels-filter'});
                    }
                }
            } else {
                win.store.set('query.msg', 'MSG_8');
                document.location.href = $url.encodeVar({ q: $url.encodeQ(this.sharedState.query)}, 
                   { url: win.internalUrl.home });
            }

            if (this.sharedState.query.stars) {
                var $star;
                var selectedStars = this.sharedState.query.stars.split(',');
                for (var star = 1; star <= 5; star++) {
                    $star = gE('star_'+star);
                    if ($star) $star.checked = selectedStars.indexOf(star.toString()) != -1;
                }
            }
            this.setCheckboxes('typ', this.sharedState.query.typ);
            this.setCheckboxes('fac', this.sharedState.query.fac);
            if (this.getCheckboxMaxIndex('typ') > 5) {
                this.toggleCollapse(null, { expand: true, target: 'property-type'});
            }
            if (this.getCheckboxMaxIndex('fac') > 5) {
                this.toggleCollapse(null, { expand: true, target: 'facilities'});
            }

        },
        getCheckboxMaxIndex: function(checkboxId) {
            var index = 0, indexMax = 0;
            for (var ref in this.$refs) {
                if (ref.indexOf(checkboxId+'_') === 0) {
                    index++;
                    if (this.$refs[ref].checked) indexMax = index;
                }
            }
            return indexMax;
        },
        setCheckboxes: function(checkboxId, checkedStr) {
            for (var id in this.$refs) {
                if (id.indexOf(checkboxId+'_') === 0) {
                    this.$refs[id].checked = !!(checkedStr & id.replace(checkboxId+'_', ''));                  
                }
            }
        },
        changeForm: function(event) {
            var fieldName = event.target.name;
            if ($d.parents(event.target, '.dates-rooms'))
            // && fieldName != 'destination' || 
             //       fieldName == 'destination' && this.withoutAvailability ||
              //      this.sharedState.dstIdSelect == null ) 
            {
                this.disabledButton = false;
            } else {
                this.submit();
            }
        },
        getHotels: function(config) {
            var cacheIsExpired = (new Date().getTime() / 1000 - this.cache.time) > this.cache.expiresSec,
                hasCachedJson = JSON.stringify(config.query) == JSON.stringify(this.cache.query) && config.offset == this.cache.offset,
                requiresRequest = (!hasCachedJson || cacheIsExpired || config.retryRequest);

            if (requiresRequest) {
                this.loading = !config.retryRequest;
                win.store.set('errorType', null);
                this.handle = win.$ajax.getJson({
                    url: win.jsonUrl.hotels,
                    params: {q : $url.encodeQ(config.query), offset: this.offset, limit: this.limit },
                    abort: this.handle,
                    scope: this,
                    timeout: 25000,
                    success: function(json) {
                        this.cache.query = JSON.parse(JSON.stringify(config.query));
                        this.availableHotels = json.availableHotels;
                        this.totalHotels = json.totalHotels;
                        this.listTotal = this.withoutavailability ? this.totalHotels : this.availableHotels;
                        this.searchRadius = !this.searchRadius ? json.defaultRadius : this.searchRadius;
                        this.setOffset(config.offset);
                        this.cache.offset = this.offset;
                        this.cache.time = new Date().getTime() / 1000;
                        win.store.set('currencyDisplay', json.currencyDisplay);
                        win.store.set('nightlyRates', json.rateConfig.nightlyRates);
                        win.store.set('errorType', json.errorType);
                        this.showResults(json);
                    },
                    failed: function(errorType) {
                        this.hotels = [];
                        this.totalHotels = 0;
                        this.availableHotels = 0;
                        this.listTotal = 0;
                        this.setOffset(config.offset);
                        win.store.set('errorType', errorType ? errorType : null);
                    },
                    always: function() {
                        this.loading = false;
                        if (config.callback) config.callback.call(config.scope);
                    }
                }); 
            } else {
                if (config.callback) config.callback.call(config.scope);
            }
    
        },
        pollTotalResults: function() {
            if (!this.totalHotels || this.withoutAvailability) return;
            this.handlePolling = win.$ajax.getJson({
                url: win.jsonUrl.hotelsPollTotal,
                params: {q : $url.encodeQ(this.cache.query) },
                abort: this.handlePolling,
                scope: this,
                success: function(json) {
                    var previousListTotal = this.listTotal;
                    this.availableHotels = json.availableHotels;
                    this.listTotal = this.availableHotels;
                    if (!this.loading && previousListTotal < this.limit && previousListTotal < this.listTotal) {
                        this.getHotels({
                            retryRequest: true,
                            query: this.cache.query,
                            offset: this.offset,
                            scope: this
                        });
                    }
                }
            });
        },
        showResults: function(json) {
            this.hotels = json.hotels || [];
            this.disabledButton = !this.sharedState.errorType;
            if (!this.listTotal && !this.sharedState.errorType) {
                win.store.set('errorType', 'noResults');
            }
        },
        submit: function(event) {
        	if (event) {
                event.preventDefault();
        	    this.startBtnLoader(event.target);
            }
            win.store.set('query.wa', 0);
            this.storeQueryObj({
        		success: function(query) {
                    this.updateHistory();
                    this.getHotels({
                        query: query,
                        offset: this.offset,
                        scope: this,
                        callback: function() {
                            if (event) this.stopBtnLoader(event.target);
                        }
                    });

        		},
                failed: function(errorType) {
                    if (event) this.stopBtnLoader(event.target);
                    // this.hotels = [];
                    win.store.set('errorType', errorType);
                }
        	});
        },
        updateHistory: function() {
            var urlParams = { q: $url.encodeQ(this.sharedState.query), offset: this.offset },
                strUrl = $url.encodeVar( urlParams, { url: win.internalUrl.search });
            win.history.pushState({query : this.sharedState.query, offset: this.offset }, '', strUrl);
        },
        onHistoryChange: function(event) {
            win.retrieveQueryObj();
            this.$children.forEach(function(autocomplete) {
               autocomplete.initAutocomplete();
            });
            this.initAvailCheck();
            this.initSearchResultList();
        },
        togglePanel: function(event) {
            this.toggleCollapse(event);
            var targetId = event.target.getAttribute('data-target');
            document.body.classList[targetId == 'hotels-filter' ? 'add' : 'remove']('hotels-filter-visible');
            this.toggleCollapse(null, {expand: false, 
                target: targetId == 'hotels-filter' ? 'hotels-sort' : 'hotels-filter'
            });
        },
        clickSortOrder: function(event) {
            if (event.target.hasAttribute('data-index')) {
                var newOrder = event.target.getAttribute('data-index');
                if (newOrder == 5 && this.sortBy == 5) {
                    this.sortOrder[newOrder] = this.sortOrder[newOrder] == 'asc' ? 'desc' : 'asc';
                } 
                this.sortBy = newOrder;
                win.store.set('sort', this.sortBy + '_' + (this.sortOrder[this.sortBy] || 'desc'));
                this.submit();
            }
        },
        setSortQueryParam: function() {
            win.store.set('sort', this.sortBy + '_' + (this.sortOrder[this.sortBy] || 'desc'));
        },
        sortClass: function(sortIndex) {
            var cls = sortIndex == this.sortBy ? 'active' : '';
            if (this.sortOrder[sortIndex]) {
                cls += ' arrow-'+(this.sortOrder[sortIndex] == 'desc' ? 'down' : 'up');
            }
            return cls;
        },
        setOffset: function(offset) {
            offset = offset || 0;
            if (typeof offset == "string") offset = parseInt(offset);
            if (offset < 0) offset = 0;
            if (this.listTotal && offset >= this.listTotal) {
                offset = Math.floor(this.listTotal / this.limit) * this.limit;
            }
            if (offset % this.limit !== 0) {
                offset = Math.floor(offset / this.limit) * this.limit;
            }
            this.offset = offset;
        },
        submitOffset: function(offset) {
            this.setOffset(offset);
            this.submit();
            $d.scrollto({ toElement: document.querySelector('.result-list-container') });
        },
        clearForm: function(section) {
            $d.forEach(document.querySelectorAll('[name^="'+section+'_"]'), function($check) {
                $check.checked = false;
            });
            this.submit();
        },
        increaseCheckout: function(days) {
            var startDate = win.calendar.parseDate(this.sharedState.query.start),
                endDate = win.calendar.addDays(win.calendar.parseDate(this.sharedState.query.end), days);
            win.calendar.updateSharedState(startDate, endDate);
            win.calendar.setSyncedCalendars({ startDate: startDate, endDate: endDate });
            this.submit();
        },
        increaseRadius: function() {
            if (this.searchRadius < this.maxRadius) {
                this.searchRadius += this.searchRadius < 10 ? 5 : 10;
            }
            if (this.searchRadius > this.maxRadius) this.searchRadius = this.maxRadius;
            this.submit();
        }
    }
});

